/* src/app/forms/gridview/salvarfiltro/salvarfiltro.component.css */
.content-container {
  width: 100%;
}
.field-error {
  color: var(--tem-danger);
  font-size: var(--tem-fs-sm);
  margin-top: var(--tem-space-1);
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.button-class {
  display: flex;
  flex-direction: row;
  gap: 10px;
  height: 100%;
  align-self: self-end;
  padding: 10px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
}
/*# sourceMappingURL=salvarfiltro.component.css.map */
